export enum StockPolicyMode {
  NOS = "NOS",
  SEASONAL = "SEASONAL",
  SELL_OUT = "SELL_OUT",
}
